import { Link } from "react-router-dom";

interface CategoryCardProps {
    title: string;
    image: string;
    url: string;
    onClick?: () => void;
    productCount: number;
    cardClassName?: string;
    imageClassName?: string;
    buttonClassName?: string;
    children?: React.ReactNode;
    animateClassName?: string; // NEW
    animationDelay?: string;   // NEW
    onMouseEnter?: () => void;
}

export default function CategoryCard({
    title,
    image,
    url,
    onClick,
    onMouseEnter,
    productCount,
    cardClassName = "",
    imageClassName = "w-full h-64 object-cover rounded-t-2xl transition-transform duration-300 group-hover:scale-105",
    buttonClassName = "mt-2 inline-block bg-harvey-red text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-harvey-red/90 transition-colors",
    children,
    animateClassName = "animate-fade-in-up",
    animationDelay = "0ms"
}: CategoryCardProps) {
    return (
        <div
            className={`group relative flex flex-col items-center bg-white rounded-2xl shadow-xl overflow-hidden transition-transform duration-300 hover:-translate-y-2 cursor-pointer ${cardClassName} ${animateClassName}`}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            style={{ animationDelay }}
        >
            <Link to={url} className="w-full h-64 block relative">
                <img
                    src={image}
                    alt={title}
                    className={imageClassName}
                    // loading="lazy"
                />
                <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity rounded-t-2xl" />
            </Link>
            <div className="flex flex-col items-center p-6">
                <h3 className="text-xl font-bold text-gray-900 text-center mb-2">
                    {title}
                </h3>
                <Link
                    to={url}
                    className={buttonClassName}
                >
                    View {productCount} Products
                </Link>
                {children}
            </div>
        </div>
    );
}